/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const SwitcherContainer = styled.div({
  maxHeight: 'calc(100vh - 75pt)',
});
